module.exports = __webpack_public_path__ + "img/task-list.f7baf8e1.svg";